export default __webpack_public_path__ + "96fd01fcb8338aa6ee2c4a46ba7662f8.ttf";